import { useState } from "react";
import { FgLogo } from "@/components/FgLogo";
import { LanguageSwitch, useLang } from "@/i18n";
import { Menu, Phone, UserRound, X } from "lucide-react";

const NAV = [
  { id: "flotta", key: "nav.fleet" },
  { id: "consegna", key: "nav.delivery" },
  { id: "offerte", key: "nav.offers" },
  { id: "contatti", key: "nav.contacts" },
];

export const Header = ({ onNav }) => {
  const [open, setOpen] = useState(false);
  const { t } = useLang();

  const go = (id) => {
    setOpen(false);
    onNav(id);
  };

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur border-b border-gray-100"
      data-testid="site-header"
    >
      <div className="max-w-6xl mx-auto h-14 px-4 flex items-center justify-between">
        <button
          className="flex items-center gap-2.5"
          onClick={() => go("top")}
          data-testid="header-logo-button"
          aria-label="FabriRent home"
        >
          <FgLogo size={34} />
          <span className="leading-none text-left">
            <span className="block font-extrabold tracking-tight text-fr-red text-[15px]">FABRIRENT</span>
            <span className="block text-[10px] text-gray-500 font-medium mt-0.5">Noleggio Auto</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-7 text-sm font-medium text-gray-600">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => onNav(n.id)} className="hover:text-fr-navy transition-colors" data-testid={`header-nav-${n.id}`}>
              {t(n.key)}
            </button>
          ))}
          <a href="/account" className="hover:text-fr-navy transition-colors" data-testid="header-nav-account">
            {t("nav.account")}
          </a>
          <a href="/partner" className="hover:text-fr-navy transition-colors" data-testid="header-nav-partner">
            {t("nav.partner")}
          </a>
          <a href="/admin" className="hover:text-fr-navy transition-colors text-gray-400" data-testid="header-nav-admin">
            {t("nav.admin")}
          </a>
          <LanguageSwitch />
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:3509656394"
            className="hidden sm:flex items-center gap-2 text-sm font-semibold text-fr-navy hover:text-fr-red transition-colors"
            data-testid="header-phone-link"
          >
            <Phone size={15} /> 350 965 6394
          </a>
          <a href="/account" className="lg:hidden p-2 text-fr-navy" aria-label="Area clienti" data-testid="header-account-link">
            <UserRound size={20} />
          </a>
          <button
            className="lg:hidden p-2 -mr-2 text-gray-700"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            data-testid="header-menu-button"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-100 bg-white shadow-lift" data-testid="header-mobile-menu">
          <nav className="px-4 py-3 flex flex-col gap-1 text-sm font-semibold text-gray-700">
            {NAV.map((n) => (
              <button
                key={n.id}
                onClick={() => go(n.id)}
                className="text-left py-2.5 border-b border-gray-50 last:border-0"
                data-testid={`mobile-menu-${n.id}`}
              >
                {t(n.key)}
              </button>
            ))}
            <a href="/account" onClick={() => setOpen(false)} className="py-2.5 border-b border-gray-50 font-bold text-fr-navy" data-testid="mobile-menu-account">
              Area clienti
            </a>
            <a href="/partner" onClick={() => setOpen(false)} className="py-2.5 border-b border-gray-50 font-bold text-fr-navy" data-testid="mobile-menu-partner">
              Partner • Hotel e B&B
            </a>
            <a href="/admin" onClick={() => setOpen(false)} className="py-2.5 text-gray-400" data-testid="mobile-menu-admin">
              Gestionale
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
